(function () {
  'use strict';

  var CART_ADD_URL = '/cart/add.js';

  function renderWidget(el) {
    var variantId   = el.dataset.variantId;
    var productUrl  = el.dataset.url;
    var imgSrc      = el.dataset.img;
    var name        = el.dataset.name        || '';
    var desc        = el.dataset.desc        || '';
    var price       = el.dataset.price       || '';
    var badge       = el.dataset.badge       || '';
    var rating      = el.dataset.rating      || '';
    var ratingCount = el.dataset.ratingCount || '';
    var tags        = el.dataset.tags        ? el.dataset.tags.split(',') : [];
    var btnText     = el.dataset.btn         || 'In den Warenkorb';
    var label       = el.dataset.label       || 'Empfohlen im Artikel';
    var weight      = el.dataset.weight      ? parseInt(el.dataset.weight, 10) : null;

    var priceNum   = price ? parseFloat(price.replace(',', '.').replace('€', '').trim()) : null;
    var pricePerKg = (priceNum && weight)
      ? (priceNum / weight * 1000).toFixed(2).replace('.', ',') + ' € / kg'
      : '';

    var imgHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + name + '" class="pk-wi-img">'
      : '<div class="pk-wi-placeholder"></div>';

    var badgeHtml = badge
      ? '<span class="pk-badge">' + badge + '</span>'
      : '';

    var starsHtml = (rating && ratingCount)
      ? '<div class="pk-stars"><span class="pk-star-filled">★★★★★</span><span class="pk-rating-text">' + rating + ' &middot; ' + ratingCount + ' Bewertungen</span></div>'
      : '';

    var tagsHtml = tags.length
      ? '<div class="pk-chips">' + tags.map(function(t){ return '<span class="pk-chip">' + t.trim() + '</span>'; }).join('') + '</div>'
      : '';

    var cartBtnHtml = variantId
      ? '<button class="pk-cta-btn" data-variant-id="' + variantId + '" aria-label="' + name + ' in den Warenkorb legen"><span class="pk-btn-icon"><svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg></span><span class="pk-btn-label">' + btnText + '</span></button>'
      : '<a class="pk-cta-link" href="' + (productUrl || '#') + '">Zum Produkt &rarr;</a>';

    el.innerHTML =
      '<div class="pk-card">' +
        '<div class="pk-img-wrap">' +
          imgHtml +
          badgeHtml +
        '</div>' +
        '<div class="pk-body">' +
          '<span class="pk-context-label">' + label + '</span>' +
          '<p class="pk-name">' + name + '</p>' +
          starsHtml +
          (desc ? '<p class="pk-desc">' + desc + '</p>' : '') +
          tagsHtml +
          '<div class="pk-footer">' +
            '<div class="pk-price-wrap">' +
              '<span class="pk-price">' + price + '</span>' +
              (pricePerKg ? '<span class="pk-price-per-kg">' + pricePerKg + '</span>' : '') +
            '</div>' +
            cartBtnHtml +
          '</div>' +
        '</div>' +
      '</div>';

    if (variantId) {
      el.querySelector('.pk-cta-btn').addEventListener('click', function () {
        addToCart(variantId, this);
      });
    }
  }

  function openCartDrawer() {
    var drawerTriggers = [
      '.cart-drawer-button',
      '[data-cart-toggle]',
      '[data-cart-open]',
      '#cart-icon-bubble',
      '.cart-count-bubble',
      '.header__icon--cart',
      '[aria-label="Cart"]',
      '[aria-label="Warenkorb"]',
      '[aria-label="Open cart"]',
      '[aria-label="Warenkorb öffnen"]',
      'a[href="/cart"].header__icon',
      '.icon-cart',
      '#CartToggle',
      '.cart-toggle'
    ];

    var triggered = false;
    for (var i = 0; i < drawerTriggers.length; i++) {
      var el = document.querySelector(drawerTriggers[i]);
      if (el) {
        el.click();
        triggered = true;
        break;
      }
    }

    if (!triggered) {
      document.dispatchEvent(new CustomEvent('cart:open'));
      document.dispatchEvent(new CustomEvent('sidebar:open', { detail: { name: 'cart' } }));
      window.dispatchEvent(new CustomEvent('cart:open'));
    }
  }

  function addToCart(variantId, btn) {
    var label = btn.querySelector('.pk-btn-label');
    btn.disabled = true;
    label.textContent = 'Wird hinzugefügt …';
    btn.classList.add('pk-loading');

    fetch(CART_ADD_URL, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId, 10), quantity: 1 })
    })
    .then(function (res) {
      if (!res.ok) throw new Error('cart_error');
      return res.json();
    })
    .then(function () {
      btn.classList.remove('pk-loading');
      btn.classList.add('pk-success');
      label.textContent = 'Im Warenkorb ✓';

      openCartDrawer();

      fetch('/cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          document.dispatchEvent(new CustomEvent('cart:updated'));
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: cart }));

          var bubbles = document.querySelectorAll('.cart-count-bubble span, #cart-icon-bubble span');
          bubbles.forEach(function (b) {
            b.textContent = cart.item_count;
          });
        });

      setTimeout(function () {
        btn.disabled = false;
        btn.classList.remove('pk-success');
        label.textContent = 'Nochmal hinzufügen';
      }, 3000);
    })
    .catch(function () {
      btn.classList.remove('pk-loading');
      btn.classList.add('pk-error');
      label.textContent = 'Fehler – nochmal versuchen';
      btn.disabled = false;
      setTimeout(function () {
        btn.classList.remove('pk-error');
        label.textContent = 'In den Warenkorb';
      }, 3000);
    });
  }

  function init() {
    document.querySelectorAll('.pk-product-widget').forEach(renderWidget);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();